module.exports = "/build/web/svg/social/small/verified-facebook.f1336a9ff7e77c0d35c1b506ed07b0ae.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/verified-facebook.svg
// module id = 113
// module chunks = 24